import React from "react";
import { ReactComponent as HandSVG } from '@svgs/hand.svg';
import { ReactComponent as SendSVG } from '@svgs/send.svg';
import { me } from '@data/me'


const Data = () => {
    return (
        <div className="home__data" >
            <h1 className="home__title">{me.displayName}
                <HandSVG />
            </h1>

            <h3 className="home__subtitle">{me.displayRole}</h3>
            <p className="home__description">{me.displayDescription}</p>
            <a href="#contact" className="button button--flex">
                Say Hello
                <SendSVG />
            </a>
        </div>
    );
}

export default Data;